import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { SEOHead } from '../components/SEOHead';
export function TermsOfServicePage() {
  const lastUpdated = 'April 2, 2026';
  return <div className="bg-viridia-black min-h-screen pt-32 pb-24" data-id="element-2794" data-mp="14xg03ypigpyp">
      <SEOHead title="Terms of Service | Viridia Analytics" description="Terms of Service for Viridia Analytics. Review the terms governing our marketing services." canonical="/terms" data-id="element-2795" data-mp="14ztus6ga405q" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2796" data-mp="r6kq2j3a02tj">
        <ScrollReveal data-id="element-2797" data-mp="r59kqeu6mn0b">
          <div className="text-center mb-16" data-id="element-2798" data-mp="r4rf4rlmqwfq">
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4" data-id="element-2799" data-mp="m8j4nridnrew">
              Terms of Service
            </h1>
            <p className="text-gray-400" data-id="element-2800" data-mp="ha7utgs31gwo">Last Updated: {lastUpdated}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.1} data-id="element-2801" data-mp="d8w1b0638bj7">
          <div className="bg-viridia-surface border border-gray-800 rounded-2xl p-8 md:p-12 prose prose-invert max-w-none" data-id="element-2802" data-mp="876rfnulq3wp">
            <div className="space-y-8 text-gray-300 leading-relaxed" data-id="element-2803" data-mp="7uyxxmptp7px">
              <section data-id="element-2804" data-mp="cn9zsv44j3l4">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2805" data-mp="cns2oalakg20">
                  1. Acceptance of Terms
                </h2>
                <p data-id="element-2806" data-mp="3v2ki3gal68sv">
                  By accessing our website or engaging Viridia Analytics ("we,"
                  "our," or "us") for services, you agree to be bound by these
                  Terms of Service. If you do not agree to these terms, please
                  do not use our services or website.
                </p>
              </section>

              <section data-id="element-2807" data-mp="hmmjx83m1wk0">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2808" data-mp="hlbivg1jv2wl">
                  2. Description of Services
                </h2>
                <p data-id="element-2809" data-mp="mmr53bfgrfgk">
                  Viridia Analytics provides digital marketing services,
                  including but not limited to ad campaign management (Google,
                  Meta, Yelp), marketing automation setup, CRM integration, and
                  web design/SEO services. The specific scope of services will
                  be outlined in a separate agreement or proposal provided to
                  the client.
                </p>
              </section>

              <section data-id="element-2810" data-mp="1330xsww6mm27">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2811" data-mp="z3ici00g88yu">
                  3. SMS/Text Messaging Terms
                </h2>
                <p className="mb-2" data-id="element-2812" data-mp="u5gu7haukdof">
                  By opting in to receive SMS communications from us, you agree
                  to the following:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2813" data-mp="k5zoizvlhzsg">
                  <li data-id="element-2814" data-mp="k6j96ocmr2a6">
                    By providing your phone number and submitting a form or
                    booking request, you consent to receive automated SMS/text
                    messages from Viridia Analytics.
                  </li>
                  <li data-id="element-2815" data-mp="2aiffyexdr0pq">
                    Messages may include appointment confirmations, reminders,
                    follow-ups, service updates, and promotional content.
                  </li>
                  <li data-id="element-2816" data-mp="197naz1uzlfj">
                    Message frequency varies. Message and data rates may apply.
                  </li>
                  <li data-id="element-2817" data-mp="620uruopp7vb">
                    You may opt out at any time by replying{' '}
                    <strong data-id="element-2818" data-mp="a19nqxbxh1pt">STOP</strong>. Reply <strong data-id="element-2819" data-mp="a1ja8axrkqqr">HELP</strong> for help.
                  </li>
                  <li data-id="element-2820" data-mp="39ire1b9b1hey">
                    Opting out of SMS does not cancel any service agreement you
                    may have with us.
                  </li>
                  <li data-id="element-2821" data-mp="3iie450wl30sp">
                    We are not responsible for charges from your mobile carrier.
                  </li>
                  <li data-id="element-2822" data-mp="3nia8505a6s89">
                    SMS consent is not required as a condition of purchasing any
                    service.
                  </li>
                  <li data-id="element-2823" data-mp="12r00p31tpxkc">
                    Carriers are not liable for delayed or undelivered messages.
                  </li>
                </ul>
              </section>

              <section data-id="element-2824" data-mp="11a32fr1bbqi5">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2825" data-mp="11bnth6of4rb9">
                  4. Client Responsibilities
                </h2>
                <p className="mb-2" data-id="element-2826" data-mp="1aareig75bgse">
                  To ensure the successful delivery of our services, you agree
                  to:
                </p>
                <ul className="list-disc pl-6 space-y-2" data-id="element-2827" data-mp="16ba9tozjmnoa">
                  <li data-id="element-2828" data-mp="1k7dzd4zh27uf">
                    Provide timely access to necessary accounts, assets, and
                    information required for campaign execution.
                  </li>
                  <li data-id="element-2829" data-mp="1txgp8wbar5oj">
                    Ensure that any materials provided to us do not infringe on
                    third-party intellectual property rights.
                  </li>
                  <li data-id="element-2830" data-mp="22yewroky1vbv">
                    Comply with the terms and policies of third-party
                    advertising platforms (e.g., Google, Meta, Yelp).
                  </li>
                  <li data-id="element-2831" data-mp="2hm58vzbv1323">
                    Review and approve campaigns or materials in a timely manner
                    when requested.
                  </li>
                </ul>
              </section>

              <section data-id="element-2832" data-mp="28lqjanrv51ss">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2833" data-mp="28kfeckmolo03">
                  5. Payment Terms
                </h2>
                <p data-id="element-2834" data-mp="2ckze7vyn35px">
                  Fees for our services are outlined in your specific service
                  agreement. Unless otherwise stated, invoices are due upon
                  receipt. We reserve the right to pause or suspend services if
                  payment is not received within the agreed-upon timeframe. Ad
                  spend (payments made directly to platforms like Google or
                  Meta) is separate from our management fees and is the sole
                  responsibility of the client.
                </p>
              </section>

              <section data-id="element-2835" data-mp="1kube8n8pc6du">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2836" data-mp="1kxpenpxt25in">
                  6. Intellectual Property
                </h2>
                <p data-id="element-2837" data-mp="3hubvvidmuadk">
                  Upon full payment for services rendered, clients retain
                  ownership of the final deliverables (e.g., website design, ad
                  copy) created specifically for them. Viridia Analytics retains
                  ownership of any proprietary tools, methodologies, or
                  pre-existing materials used in the delivery of services.
                </p>
              </section>

              <section data-id="element-2838" data-mp="4fp2ndbu9bxe">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2839" data-mp="4d2y7mk8vcje">
                  7. Limitation of Liability
                </h2>
                <p data-id="element-2840" data-mp="3rkenpf90piab">
                  While we strive to deliver the best possible results, Viridia
                  Analytics does not guarantee specific outcomes, such as a
                  certain number of leads or revenue, as these depend on various
                  market factors. In no event shall Viridia Analytics be liable
                  for any indirect, incidental, special, or consequential
                  damages arising out of or in connection with our services.
                </p>
              </section>

              <section data-id="element-2841" data-mp="14mkgeh1ecjad">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2842" data-mp="14l99w9gkgxfk">
                  8. Termination
                </h2>
                <p data-id="element-2843" data-mp="1ed5kul3r4i17">
                  Either party may terminate the service agreement with written
                  notice as specified in the individual contract. Upon
                  termination, the client is responsible for payment for all
                  services rendered up to the termination date.
                </p>
              </section>

              <section data-id="element-2844" data-mp="1sceqiqubztqx">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2845" data-mp="1sau45oi67h45">
                  9. Governing Law
                </h2>
                <p data-id="element-2846" data-mp="3u41k905ly2r3">
                  These Terms of Service shall be governed by and construed in
                  accordance with the laws of the State of Arizona, without
                  regard to its conflict of law provisions. Any legal action or
                  proceeding arising under these terms shall be brought
                  exclusively in the courts located in Phoenix, Arizona.
                </p>
              </section>

              <section data-id="element-2847" data-mp="3g02ojpf5z0rb">
                <h2 className="text-2xl font-bold text-white mb-4" data-id="element-2848" data-mp="3g0vuio6atm8e">
                  10. Contact Information
                </h2>
                <p className="mb-2" data-id="element-2849" data-mp="2nadjn0zc2gkf">
                  If you have any questions about these Terms of Service, please
                  contact us:
                </p>
                <ul className="list-none space-y-1" data-id="element-2850" data-mp="317sdqj0j7ciq">
                  <li data-id="element-2851" data-mp="2w9qu9wz71b6q">
                    <strong data-id="element-2852" data-mp="2w98r0ge45wpb">Company:</strong> Viridia Analytics
                  </li>
                  <li data-id="element-2853" data-mp="gicqtz4fo7yd">
                    <strong data-id="element-2854" data-mp="ght9okmlxnle">Location:</strong> Phoenix, AZ
                  </li>
                  <li data-id="element-2855" data-mp="bjrpfwdg3i8c">
                    <strong data-id="element-2856" data-mp="bmno5mx4aaxu">Email:</strong>{' '}
                    <a href="mailto:info@viridiaanalytics.com" className="text-viridia hover:underline" data-id="element-2857" data-mp="k1bv0hwz1k9m">
                      info@viridiaanalytics.com
                    </a>
                  </li>
                  <li data-id="element-2858" data-mp="a5qoc6gyjvtj">
                    <strong data-id="element-2859" data-mp="f1ywv10ngqrq">Phone:</strong>{' '}
                    <a href="tel:6233000708" className="text-viridia hover:underline" data-id="element-2860" data-mp="f2qu0g9wawk4">
                      (623) 300-0708
                    </a>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </div>;
}